import React from 'react';

export const LeaderboardName = ({ name }: { name: string }) => {
    return (
        <div className="fs-16">
            <div className="c-white">{name}</div>
        </div>
    );
};
